module.exports = __webpack_public_path__ + "img/terroir-wavy-1-mobile.64203466.jpg";